/** Shape returned by backend SuccessResponse.paginate */
export type PaginatedApiPayload<T> = {
  items?: T[];
  /** Current page row count only — do not use for TablePagination count */
  total?: number;
  totalRecords?: number;
  pageNo?: number;
  pageSize?: number;
};

/**
 * Maps paginated API payload to list + total for MUI TablePagination.
 * Backend puts the full row count in `totalRecords`; `total` is items on this page.
 */
export function parsePaginatedList<T>(
  payload: PaginatedApiPayload<T> | null | undefined
): { data: T[]; total: number; pageNo: number; pageSize: number } {
  const data = payload?.items ?? [];
  const total = payload?.totalRecords ?? payload?.total ?? 0;
  return {
    data,
    total: Number(total) || 0,
    pageNo: payload?.pageNo ?? 1,
    pageSize: payload?.pageSize ?? data.length,
  };
}

/** Dropdown APIs: raw array or paginated `{ items }` — never pass through a bare paginated object. */
export function asList<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === "object") {
    const items = (payload as PaginatedApiPayload<T>).items;
    if (Array.isArray(items)) return items;
  }
  return [];
}

/** React Query key for branch/salesPoint dropdowns (must not share `["branches"]` with paginated list). */
export const BRANCHES_ALL_QUERY_KEY = ["branches", "all"] as const;
export const SALES_POINTS_ALL_QUERY_KEY = ["sales_points", "all"] as const;
